// React Query keys used by the shared client-file areas. The values MUST stay identical to the
// internal app's QueryKey enum (src/query/Query.ts) — other internal features invalidate these
// caches cross-feature (e.g. after actions that change claims), and that collision only works when
// both sides use the same runtime strings. Extend alongside each lifted area.
export enum ClientFileQueryKey {
  AssetInventory = "assetInventory",
  AssetInventoryBankStatements = "assetInventoryBankStatements",
  AssetInventoryCompleteness = "assetInventoryCompleteness",
  AssetInventoryExpenses = "assetInventoryExpenses",
  AssetInventoryIncome = "assetInventoryIncome",
  AssetInventoryIncomeProofs = "assetInventoryIncomeProofs",
  AssetInventoryExpenseProofs = "assetInventoryExpenseProofs",
  AssetInventoryExpensePartner = "assetInventoryExpensePartner",
  AssetInventoryOwnClaims = "assetInventoryOwnClaims",
  AssetInventoryOwnClaimDocuments = "assetInventoryOwnClaimDocuments",
  AssetInventoryAssets = "assetInventoryAssets",
  AssetInventoryDomesticRealEstateDocuments = "assetInventoryDomesticRealEstateDocuments",
  AssetInventoryForeignRealEstateDocuments = "assetInventoryForeignRealEstateDocuments",
  AssetInventoryBuildingSavingsContractDocuments = "assetInventoryBuildingSavingsContractDocuments",
  AssetInventorySavingsAccountDocuments = "assetInventorySavingsAccountDocuments",
  AssetInventoryLifeInsuranceDocuments = "assetInventoryLifeInsuranceDocuments",
  AssetInventoryPensionInsuranceDocuments = "assetInventoryPensionInsuranceDocuments",
  AssetInventorySecuritiesDepotDocuments = "assetInventorySecuritiesDepotDocuments",
  AssetInventoryCashAndBankAssetDocuments = "assetInventoryCashAndBankAssetDocuments",
  AssetInventoryVehicleDocuments = "assetInventoryVehicleDocuments",
  AssetInventoryBuildingsOnForeignLandDocuments = "assetInventoryBuildingsOnForeignLandDocuments",
  AssetInventoryPropertyRights = "assetInventoryPropertyRights",
  AssetInventoryTenancyRightDocuments = "assetInventoryTenancyRightDocuments",
  AssetInventoryCompanyShareDocuments = "assetInventoryCompanyShareDocuments",
  AssetInventoryCooperativeMembershipDocuments = "assetInventoryCooperativeMembershipDocuments",
  AssetInventoryOtherPropertyRightDocuments = "assetInventoryOtherPropertyRightDocuments",
  AssetInventoryDonations = "assetInventoryDonations",
  AssetInventoryDonationDocuments = "assetInventoryDonationDocuments",
  AssetInventoryDependants = "assetInventoryDependants",
  AssetInventoryDependantDocuments = "assetInventoryDependantDocuments",
  BankruptcyChecklist = "bankruptcyChecklist",
  Client = "client",
  ClientClaims = "clientClaims",
  ClientNote = "clientNote",
  ClaimById = "claimById",
  ClientPersonalData = "clientPersonalData",
  ProceedingParticipants = "proceedingParticipants",
  DropdownOptions = "dropdownOptions",
  SystemDropdownOptions = "systemDropdownOptions",
  ViennaAddresses = "viennaAddresses",
}
